import React from "react";
import { mailIcon } from "./SVG";

export default function Footer() {
  return (
    <footer className="footer" id="footer">
      <div className="auto__container">
        <div className="footer__inner">
          <div className="footer__inner-top">
            <div className="footer__bg"></div>
            <div className="footer__inner-image">
              <img src="/images/gif.gif" alt="" />
            </div>
            <h2>For Business Inquiries</h2>
            <a href="mailto:amit@alo-x.hair" className="button primary big">
              {mailIcon}
              Amit@alo-x.hair
            </a>
          </div>
          <div className="footerMain">
            <div className="footerMain__row">
              <hr />
              <a href="#top" className="footerMain__logo">
                <img src="/images/Proxium_Logo_final-02.png" alt="" />
              </a>
              <hr />
            </div>
            <div className="footerMain__links">
              <a href="#about">About</a>
              <a href="#">Contact</a>
              <a href="/terms">
                {" "}
                <b>Terms & Conditions</b> <span>Terms and Conditions</span>
              </a>
              <a href="/privacy">Privacy Policy</a>
              <a href="#">Consumer Health Data</a>
            </div>
            <div className="footerMain__copy">
              <p>This website was designed by Anna Drizo - www.visuanna.com</p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
